/**
 *
 * @module entry
 * @desc {SDK.Content.Search} entry point.
 *
 */

import SearchExtensions from './searchExtensions';
import SearchQuery from './searchQuery';

/**
 *
 * @typedef SDK.Content.Search
 * @type {Object}
 *
 * @property {SearchExtensions} SearchExtensions
 * @property {SearchQuery} SearchQuery
 *
 */

/**
 *
 * @type {SDK.Content.Search}
 *
 */
export default {

    SearchExtensions,
    SearchQuery

};



// WEBPACK FOOTER //
// ./src/content/search/entry.js